module.exports = "<app-navbar></app-navbar>\n<section class=\"content\">\n    <div class=\"container-fluid\">\n        <div class=\"block-header\">\n            <h2 class=\"text-uppercase\">\n                {{currentEndpoint?.page_title | translate}}\n                <!--<small translate>{{currentEndpoint?.page_desc}}</small>-->\n            </h2>\n        </div>\n        <div class=\"row clearfix\">\n            <ui-view></ui-view>\n        </div>\n    </div>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main